export const MFA_PROVISIONING_URL = "/user/multi_factor_provisionings/new";
export const VALIDATION_URL = "/user/multi_factor_provisionings/validate";
export const SUBMIT_FORM_URL = "/user/multi_factor_provisionings";
